<template>
  <b-card no-body class="mb-2">
    <b-card-body>
      <h1>
        {{ blackTitle }} <span>{{ blueTitle }}</span>
      </h1>
    </b-card-body>
  </b-card>
</template>
<script>
  export default {
    props: {
      blackTitle: {
        type: String,
        required: true
      },
      blueTitle: {
        type: String,
        required: true
      }
    }
  }
</script>
<style>
  h1 {
    text-align:center;
    margin-bottom: 0px;
  }
  h1 span {
    color: #6CB9D5;
  }
</style>
